import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["size", "mode", "theme", "className", "triggerRef", "isOpen", "selected", "placeholder", "isClearable", "isLoading", "isDisabled", "isSingleLine", "searchInput", "isSearchable", "onClearClick", "onItemClearClick", "onSearchChange", "error"];
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { presets, RemovableTag, Tag } from '@rescui/tag';
import { useTheme } from '@rescui/ui-contexts';
import { DownIcon, LoadingIcon, CloseIcon } from '@rescui/icons';
import { optionType } from '../common-prop-types.js';
import { reverseTheme } from '../utils.js';
import Foldable from './foldable.js';
import styles from './trigger.p.module.css.js';
/* eslint-disable no-nested-ternary */

var TAG_PRESET = {
  light: presets.filledLight,
  dark: presets.filledDark
};
var THEME_STYLES = {
  light: styles.themeLight,
  dark: styles.themeDark
};
var SIZE_STYLES = {
  s: styles.sizeS,
  m: styles.sizeM,
  l: styles.sizeL
};
var MODE_STYLES = {
  classic: styles.classic,
  rock: styles.rock
};
var TAG_SIZE = {
  s: 'xs',
  m: 's',
  l: 'm'
}; // eslint-disable-next-line complexity

var SelectTrigger = /*#__PURE__*/React.memo(function (props) {
  var size = props.size,
      mode = props.mode,
      themeFromProps = props.theme,
      className = props.className,
      triggerRef = props.triggerRef,
      isOpen = props.isOpen,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? null : _props$selected,
      placeholder = props.placeholder,
      isClearable = props.isClearable,
      isLoading = props.isLoading,
      isDisabled = props.isDisabled,
      isSingleLine = props.isSingleLine,
      searchInput = props.searchInput,
      isSearchable = props.isSearchable,
      onClearClick = props.onClearClick,
      onItemClearClick = props.onItemClearClick,
      onSearchChange = props.onSearchChange,
      error = props.error,
      restProps = _objectWithoutProperties(props, _excluded);

  var theme = useTheme(themeFromProps);
  var inputRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isSearchFocused = _useState2[0],
      setIsSearchFocused = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isFocused = _useState4[0],
      setIsFocused = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isSearchKeyFocused = _useState6[0],
      setIsSearchKeyFocused = _useState6[1];

  var isMulti = selected ? Boolean(selected.length) : false;

  var handleChange = function handleChange(event) {
    var newValue = event.target.value;
    onSearchChange(newValue);
  };

  var handleBlur = function handleBlur() {
    if (isSearchable && inputRef.current) {
      setIsSearchFocused(false);
      setIsSearchKeyFocused(false);
    }
  };

  var handleFocus = function handleFocus(e) {
    if (isSearchable && inputRef.current) {
      setIsSearchFocused(true);
      var target = e.target;
      setIsSearchKeyFocused(target.getAttribute('data-focus-method') === 'key');
    }
  };

  var isThemeReversed = mode === 'rock' && (isSearchFocused || isFocused || isOpen);
  return /*#__PURE__*/React.createElement("div", _objectSpread({
    tabIndex: isSearchable || isDisabled ? -1 : 0,
    className: cn(styles.main, SIZE_STYLES[size], MODE_STYLES[mode], THEME_STYLES[theme], isMulti && styles.isMulti, isSearchFocused && styles.searchFocused, isSearchKeyFocused && styles.searchKeyFocused, isOpen && styles.open, isDisabled ? styles.disabled : styles.enabled, Boolean(error) && styles.error, isFocused && styles.focused, className),
    onFocus: function onFocus(e) {
      var target = e.target;
      setIsFocused(target.getAttribute('data-focus-method') === 'key');
    },
    onBlur: function onBlur() {
      return setIsFocused(false);
    },
    ref: triggerRef,
    "data-test": "select"
  }, restProps), isMulti ? /*#__PURE__*/React.createElement(MultiselectOptions, {
    selected: selected,
    size: size,
    isDisabled: isDisabled,
    isSingleLine: isSingleLine,
    onItemClearClick: onItemClearClick,
    theme: theme,
    isThemeReversed: isThemeReversed
  }) : /*#__PURE__*/React.createElement(SelectedOption, {
    selected: selected,
    placeholder: placeholder,
    searchInput: searchInput,
    isSearchable: isSearchable,
    isDisabled: isDisabled,
    inputRef: inputRef,
    handleBlur: handleBlur,
    handleFocus: handleFocus,
    handleChange: handleChange
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.iconsWrapper
  }, /*#__PURE__*/React.createElement(ClearOrLoading, {
    isLoading: isLoading,
    isDisabled: isDisabled,
    isClearable: isClearable,
    onClearClick: onClearClick,
    selected: selected,
    size: size
  }), /*#__PURE__*/React.createElement(DownIcon, {
    size: size,
    className: styles.toggle,
    "data-test": "down-icon"
  })));
});
SelectTrigger.displayName = 'SelectTrigger';

var MultiselectOptions = function MultiselectOptions(_ref) {
  var isSingleLine = _ref.isSingleLine,
      selected = _ref.selected,
      isThemeReversed = _ref.isThemeReversed,
      size = _ref.size,
      isDisabled = _ref.isDisabled,
      onItemClearClick = _ref.onItemClearClick,
      theme = _ref.theme;

  var selectedOptions = _mapInstanceProperty(selected).call(selected, function (s) {
    var key = s.value ? s.value : s.label;
    return /*#__PURE__*/React.createElement(RemovableTag, {
      key: key,
      "data-test": "selected-tag-".concat(key),
      className: styles.tag,
      disabled: isDisabled,
      onRemoveClick: function onRemoveClick() {
        return onItemClearClick(s);
      },
      size: TAG_SIZE[size],
      wrap: !isSingleLine,
      theme: isThemeReversed ? reverseTheme(theme) : theme
    }, s.label);
  });

  return /*#__PURE__*/React.createElement("div", {
    className: styles.multi,
    "data-test": "multi"
  }, isSingleLine ? /*#__PURE__*/React.createElement(Foldable, {
    className: styles.tagsContainer,
    renderHiddenCounter: function renderHiddenCounter(n, ref) {
      return /*#__PURE__*/React.createElement(Tag, _objectSpread({
        className: styles.tag,
        key: "+",
        ref: ref,
        size: TAG_SIZE[size]
      }, TAG_PRESET[isThemeReversed ? reverseTheme(theme) : theme]), "+".concat(n));
    },
    gap: {
      l: 8,
      m: 4,
      s: 4
    }[size]
  }, selectedOptions) : /*#__PURE__*/React.createElement("div", {
    className: styles.tagsContainer
  }, selectedOptions));
};

function isSelectedEmpty(selected) {
  if (Array.isArray(selected)) {
    return selected.length === 0;
  } else {
    return !selected;
  }
} // eslint-disable-next-line complexity


var SelectedOption = function SelectedOption(_ref2) {
  var selected = _ref2.selected,
      _ref2$searchInput = _ref2.searchInput,
      searchInput = _ref2$searchInput === void 0 ? '' : _ref2$searchInput,
      _ref2$placeholder = _ref2.placeholder,
      placeholder = _ref2$placeholder === void 0 ? '' : _ref2$placeholder,
      isSearchable = _ref2.isSearchable,
      isDisabled = _ref2.isDisabled,
      inputRef = _ref2.inputRef,
      handleBlur = _ref2.handleBlur,
      handleFocus = _ref2.handleFocus,
      handleChange = _ref2.handleChange;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.labelWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.label, isSelectedEmpty(selected) && styles.notSelected),
    "data-test": "select-content"
  }, searchInput === '' ? selected && selected.label ? selected.label : placeholder : ''), isSearchable && !isDisabled && /*#__PURE__*/React.createElement("input", {
    ref: inputRef,
    tabIndex: isSearchable ? 0 : -1,
    onBlur: handleBlur,
    onFocus: handleFocus,
    className: styles.searchInput,
    autoCapitalize: "none",
    autoComplete: "off",
    autoCorrect: "off",
    spellCheck: "false",
    type: "text",
    value: searchInput,
    onChange: handleChange,
    "data-test": "search-input"
  }));
};

var ClearOrLoading = function ClearOrLoading(_ref3) {
  var isClearable = _ref3.isClearable,
      isLoading = _ref3.isLoading,
      isDisabled = _ref3.isDisabled,
      onClearClick = _ref3.onClearClick,
      selected = _ref3.selected,
      size = _ref3.size;

  if (isLoading) {
    return /*#__PURE__*/React.createElement(LoadingIcon, {
      style: {
        pointerEvents: 'none'
      },
      size: size,
      className: styles.icon,
      "data-test": "loading-icon"
    });
  } else if (isClearable && !isDisabled && !isSelectedEmpty(selected)) {
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: cn(styles.icon, styles.clearIcon),
      "data-test": "clear-icon",
      onClick: function onClick(e) {
        e.stopPropagation();
        onClearClick();
      }
    }, /*#__PURE__*/React.createElement(CloseIcon, {
      size: size
    }));
  } else {
    return null;
  }
};

SelectTrigger.propTypes = {
  size: PropTypes.oneOf(['m', 's', 'l']),
  mode: PropTypes.oneOf(['classic', 'rock']),
  theme: PropTypes.oneOf(['light', 'dark']),
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  selected: PropTypes.oneOfType([optionType, PropTypes.arrayOf(optionType)]),
  placeholder: PropTypes.string,
  isClearable: PropTypes.bool,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isSearchable: PropTypes.bool,
  isSingleLine: PropTypes.bool,
  onClearClick: PropTypes.func,
  onItemClearClick: PropTypes.func,
  onSearchChange: PropTypes.func,
  error: PropTypes.bool,
  triggerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),
  searchInput: PropTypes.string
};
export { SelectTrigger as default };
